import { useTranslation } from 'react-i18next'
import { Item, ItemLabel, ItemValue } from '../_styles'
import { useProduct } from '../../../_methods'

const ClosureType = () => {
  const { t } = useTranslation()
  const product = useProduct()

  const closureType = product?.closureType?.localizedName

  if (!closureType) return null

  return (
    <Item>
      <ItemLabel>{t('wine.view.closureType')}</ItemLabel>
      <ItemValue>{closureType}</ItemValue>
    </Item>
  )
}

export default ClosureType
